import styleVars from './FolderCard.scss';
export const getPadding = ()=>{
    return 2 * parseInt(styleVars['padding'], 10);
};
export const getFooterMargin = ()=>{
    return parseInt(styleVars['footerMargin'], 10);
};
export const getFooterHeight = (folderCardHeight)=>{
    return shouldShowStats(folderCardHeight) ? parseInt(styleVars['footerHeightWithStats'], 10) : parseInt(styleVars['footerHeight'], 10);
};
export const shouldShowStats = (folderCardHeight)=>{
    return folderCardHeight > 150;
};
